const MODEL_TEMPLATE = {
  targeting: {
    ageFrom: 13,
    ageTo: 65,
    customAudiences: [null],
    excludedCustomAudiences: [],
    genders: 0,
    excludedGeoLocations: [],
    excludedGeoLocationsTypes: "home",
    excludedInterests: [],
    interestsGroups: [],
    geoLocations: [],
    geoLocationsTypes: "home,recent",
  },
}

export { MODEL_TEMPLATE }
